import clsx from 'clsx'
import { ProductsSlider } from '../ProductsSlider/ProductsSlider'
import { LoadingItems } from '../RecommendedProducts/components/LoadingItems'
import { useCioRecommendations } from './hooks/useCioRecommendations'
import { FC } from 'react'
import { mapProduct } from '../SearchResultPageCio/lib/mapProduct'
import { useInView } from 'react-intersection-observer'
import { RecommendationsParameters } from '@constructor-io/constructorio-client-javascript'
import { ProductCard } from '../ProductCard/ProductCard'

type CioRecommendationsProps = {
  podId: string
  headline: string
  params?: RecommendationsParameters
  className?: string
}

export const CioRecommendations: FC<CioRecommendationsProps> = ({
  podId,
  params,
  headline,
  className,
}) => {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.5 })
  const {
    recommendations,
    podId: responsePodId,
    resultId,
    totalResultsFound,
    isLoading,
    isEnabled,
  } = useCioRecommendations(podId, params, inView)

  if (!isEnabled) {
    return null
  }

  return (
    <div
      ref={ref}
      className={clsx(className, 'content-width overflow-hidden pl-5 lg:px-[50px]')}
      data-cnstrc-recommendations
      data-cnstrc-recommendations-pod-id={responsePodId}
      data-cnstrc-result-id={resultId}
      data-cnstrc-num-results={isLoading ? undefined : totalResultsFound || 0}
    >
      {isLoading && <LoadingItems />}
      {(recommendations || []).length > 0 && (
        <div className="max-w-[1354px]">
          <ProductsSlider
            products={recommendations?.map((item) => mapProduct(item)) ?? []}
            headlineText={headline}
            renderSlide={(product, index, isSlideVisible) => {
              return (
                <ProductCard
                  useCio
                  className={clsx(
                    'border-none !p-0 transition-opacity duration-500',
                    isSlideVisible ? 'opacity-100' : 'opacity-0',
                  )}
                  cioItemType="recommendation"
                  cioStrategyId={
                    recommendations?.find((_, recoIndex) => index === recoIndex)?.strategy?.id ||
                    undefined
                  }
                  product={product}
                  productPrice={product}
                  isSlider
                  withCioAttributes
                />
              )
            }}
          />
        </div>
      )}
    </div>
  )
}
